import { McpForm } from '../form/McpForm';
import { t } from '../../i18n';
import type { ChipFormState } from './MessageList.helpers';

interface MessageListChipFormProps {
  state: ChipFormState;
  onSubmit: (values: Record<string, unknown>) => void;
  onCancel: () => void;
}

export function MessageListChipForm({
  state,
  onSubmit,
  onCancel,
}: MessageListChipFormProps) {
  return (
    <div className="chip-form-container">
      <McpForm
        fields={state.fields}
        submitLabel={t('formSubmit')}
        cancelLabel={t('formCancel')}
        onCancel={onCancel}
        onSubmit={onSubmit}
        formType="chip"
        toolName={state.toolName}
        rootAttributes={{ 'data-chip-text': state.chipText }}
        autoFocusFirstField
      />
    </div>
  );
}
